var BASWebServices;
(function (BASWebServices) {
    var ScrollController = (function () {
        function ScrollController($scope, $rootScope, $state, $location, $anchorScroll, $timeout, serviceID) {
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$state = $state;
            this.$location = $location;
            this.$anchorScroll = $anchorScroll;
            this.$timeout = $timeout;
            this.serviceID = serviceID;
            $scope.sc = this;
            var loc = $location;
            var scroll = $anchorScroll;
            $timeout(function () {
                loc.hash(serviceID);
                scroll();
            }, 200);
            $location.hash(serviceID);
            $anchorScroll();
        }
        return ScrollController;
    }());
    BASWebServices.ScrollController = ScrollController;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=ScrollController.js.map